import { Tree, Card, Tabs, Row, Col, Checkbox, Typography, Tooltip, Button, Modal, Pagination, Input, Tag } from 'antd'
import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { SearchOutlined, DeleteOutlined, EnterOutlined } from '@ant-design/icons';
import { app, use, api } from 'xadmin'
import permissions from '../permissions'
import NoData from './../../../components/NoData'
import { Icon, Loading, C } from 'xadmin-ui';
const { Search } = Input
const { TabPane } = Tabs
const { TreeNode } = Tree
const { Text } = Typography;

const CheckboxGroup = Checkbox.Group

const PermissionField = props => {
  const [permission, setPermission] = React.useState(null)
  const { user, user: { permissions: userPermissions } } = use('redux', state => ({ user: state.user }))

  const findPermission = (key) => {
    if (user?.isSuper) return true
    return userPermissions.indexOf(key) > -1
  }

  React.useEffect(() => {
    const models = app.get('models')
    //工作表权限
    if (Object.keys(models).indexOf('Table') > -1 && findPermission('table.view')) {
      api({ name: '/core/table' }).query({ fields: ['schema'] }, {})
        .then(({ items }) => {
          const newData = _.compact(items.map(opt => ({ schema: opt.schema, name: opt.name }))).map(model => {
            const name = (model.name)
            const rolePermission = model.rolePermission || [
              { key: `ext_${name}.view`, title: '查看' },
              { key: `ext_${name}.add`, title: '创建' },
              { key: `ext_${name}.edit`, title: '修改' },
              { key: `ext_${name}.delete`, title: '删除' },
            ]
            return {
              key: 'ext_' + name, title: name, children: [
                ...rolePermission,
                ...(permissions[name] ? permissions[name].children : [])
              ]
            }
          })
          setPermission(state => ([...state, ...newData]))
        })
    }
    let fields = ["name", "type", "cover", "focus", "isDelete"]
    let wheres = { isDelete: { "$ne": true } }
    findPermission('dashboard.view') && api({ name: 'core/dashboard' }).query({ fields }, { wheres }).then(({ items }) => {
      const newData = _.compact(items.map(opt => ({ name: opt.name, id: opt?.id }))).map(model => {
        const name = (model.id)
        const rolePermission = model.rolePermission || [
          { key: `dashboard_${model?.id}.view`, title: '查看' },
          { key: `dashboard_${model?.id}.edit`, title: '修改' },
          { key: `dashboard_${model?.id}.delete`, title: '删除' },
        ]
        return {
          key: 'dashboard_' + name, title: model?.name, children: [
            ...rolePermission,
            ...(permissions[name] ? permissions[name].children : [])
          ]
        }
      })
      setPermission(state => ([...state, ...newData]))
    })
    const modelPermission = Object.values(models)
      .filter(model => !model?.noAuth)
      .filter(model => (model.name || model.title) && (model.name || model.title).indexOf('auth_') != 0)
      .map(model => {
        const name = model?.notoLowerCase ? model.name : (model.name)?.toLowerCase()

        const rolePermission = model.rolePermission || [
          { key: `${name}.view`, title: '查看' },
          { key: `${name}.add`, title: '创建' },
          { key: `${name}.edit`, title: '修改' },
          { key: `${name}.delete`, title: '删除' },
        ]
        return {
          key: name, title: model.title, children: [
            ...rolePermission,
            ...(permissions[name] ? permissions[name].children : [])
          ]
        }

      })
    const defPermission = Object.keys(permissions).filter(key => models[key] == undefined).map(key => {
      return ({
        ...permissions[key],
        key
      })
    })
    // const modelsPermission = types ? Object.values(types).map(et => ({
    //   key: `=models-${et.id}`, title: et.name, children: app.array('modelPermissions').map(p => p(et, `models-${et.id}`))
    // })) : []

    // const permission = modelPermission.concat(defPermission).concat([{
    //   key: '=models.settings', title: '资产类型权限',
    //   children: modelsPermission
    // }])

    // 视频权限
    // const videoPermission = [['camera', '视频监控地址'], ['play', '视频监控播放']].map(k => {
    //   return {
    //     key: k[0],
    //     title: k[1],
    //     children: [
    //       { key: `${k[0]}.view`, title: '查看' },
    //       { key: `${k[0]}.add`, title: '创建' },
    //       { key: `${k[0]}.edit`, title: '修改' },
    //       { key: `${k[0]}.delete`, title: '删除' },
    //     ]
    //   }
    // })
    const permission = modelPermission.concat(defPermission) //.concat(videoPermission)
    // const roleItem = permission.find(item => item.key === 'role');
    // roleItem.children.push({ key: 'role.copy', title: '复制' });
    const userIndex = permission.findIndex(item => item.key === 'user');
    if (userIndex !== -1) {
      permission[userIndex].children.push({ key: 'user.examine', title: '审核' });
    }
    const taskmanageIndex = permission.findIndex(item => item.key === 'taskmanager');
    if (taskmanageIndex !== -1) {
      permission[taskmanageIndex].children.push({ key: 'taskmanager.ongoing', title: '启动' }, { key: 'taskmanager.pause', title: '中止' });
    }
    setPermission(permission.filter(v => Boolean(v)))
  }, [])

  if (permission == null) {
    return <Loading />
  }

  const { input, options, label, meta, field } = props

  const renderTreeNode = ps => ps.children ? (
    <TreeNode title={ps.title} key={ps.key}>
      {ps.children.map(pc => renderTreeNode(pc))}
    </TreeNode>
  ) : <TreeNode title={ps.title} key={ps.key} />
  return (
    <Card>
      <PermissionTabs inputOnChange={input.onChange} permission={permission} defaultCheckedKeys={input.value || ['homeDashboardConfig.view', 'homeDashboardConfig']} />
    </Card>
  )
}

export default PermissionField

const tabs = [
  { name: '资产、设备相关', key: 'node' },
  { name: '功能模块', key: 'function' },
  { name: '系统相关', key: 'system' },
  { name: '权限相关', key: 'auth' },
  { name: '业务相关', key: 'business' },
  { name: '工作表', key: 'table' },
  { name: '报表', key: 'reports' },
  { name: '数据接口', key: 'data' },
  { name: '其他', key: 'else' },
]

const compatibleData = (defaultCheckedKeys, obj, current, goal) => {
  let blank = current.substr(0, current.indexOf('.'))
  if (defaultCheckedKeys.indexOf(current) != -1) {
    obj[goal] = obj[goal] ? _.uniq([...obj[goal], current]) : [current]
    obj[blank] = []
  }
}

const convert_values = (defaultCheckedKeys = []) => {
  const obj = defaultCheckedKeys.reduce((prev, cur, index, arr) => {
    // if (cur.indexOf('.') != -1 && cur.indexOf('-') == -1) {
    // 避免工作表名称带’-‘修改判断条件
    if (cur.indexOf('.') != -1) {
      const key_code = cur.split('.')
      prev[key_code[0]] = Array.from(new Set(arr.filter(key => {
        //原有判断逻辑导致相似的key重复  使权限不好用  更改后可处理 相似权限字段导致的问题
        let a = key.split('.')[0] + '.'
        let b = key_code[0] + '.'
        return key.indexOf(key_code[0] + '.') != -1 && a == b // 原有判断逻辑：key.indexOf(key_code[0] + '.') != -1
      })))
    }
    return prev
  }, {})
  //  analysis 老数据处理
  const analysis = ['analysis.view', 'analysis.export']
  analysis.forEach(val => {
    compatibleData(defaultCheckedKeys, obj, val, 'data')
  })
  // 视频数据处理
  const ezopen = ['preview.view', 'ptz.add']
  ezopen.forEach(val => {
    compatibleData(defaultCheckedKeys, obj, val, 'ezopen')
  })
  const summary = ['gb28181.view', 'gb28181.add', 'stream.view']
  summary.forEach(val => {
    compatibleData(defaultCheckedKeys, obj, val, 'summary')
  })
  const playback = ['live.add', 'live.view']
  playback.forEach(val => {
    compatibleData(defaultCheckedKeys, obj, val, 'playback')
  })
  // if (defaultCheckedKeys.indexOf('analysis.view') != -1) {
  //   obj['data'] = obj['data'] ? _.uniq([...obj['data'], 'analysis.view']) : ['analysis.view']
  //   obj['analysis'] = []
  // }
  // if (defaultCheckedKeys.indexOf('analysis.export') != -1) {
  //   obj['data'] = obj['data'] ? _.uniq([...obj['data'], 'analysis.export']) : ['analysis.export']
  //   obj['analysis'] = []
  // }
  const arr = ['dashboard_detailFilter', 'dashboard_deafultview', 'dashboard_deafultedit', 'dashboard_deafultdelete']
  arr.forEach(val => {
    if (defaultCheckedKeys.indexOf(val) > -1) {
      obj[val] = []
    }
  })

  return obj
}

const PermissionTabs = ({ permission, defaultCheckedKeys, inputOnChange }) => {
  const [activeKey, setActiveKey] = React.useState('node')      //选择tab的Key
  const [checkedList, setCheckedList] = React.useState(convert_values(defaultCheckedKeys)) // 所有选中数据
  const Initdata = checkedList     // 存储初始数据

  const tab_convert = (keys, sign) => { // 处理数据

    if (!keys) return []
    let tabs = []
    if (sign) {
      //工作表
      const tables = permission.filter(item => !(item?.key?.indexOf('ext_') > -1))
      tabs = _.differenceBy(tables, keys.map(key => ({ 'key': key })), 'key')

      keys.forEach(key => {
        permission.forEach(tab => {
          //电子签名
          if (key == 'signature' && tab.key.indexOf('signature') > -1) tabs.push(tab)
        })
      })
    } else {
      keys.forEach(key => {
        permission.forEach(tab => {
          if (tab?.key?.toLowerCase() == key?.toLowerCase()) {
            //操作日志
            if (tab.key == 'log' && key == 'log') {
              tab.children.splice(2, 3); tabs.push(tab)
            } else {
              tabs.push(tab)
            }
          }
          //工作表
          if (key == 'table' && tab?.key?.indexOf('ext_') > -1) tabs.push(tab)
        })
      })
    }

    return tabs
  }

  const convert_data = (checkedList) => { // 转换保存时的数据格式
    if (JSON.stringify(checkedList) == '{}') return []
    const data = Object.keys(checkedList).map(item => checkedList[item].concat(item))
    return _.flattenDeep(data)
  }

  React.useEffect(() => { // 存储数据
    inputOnChange(convert_data(checkedList))
  }, [checkedList])

  const TABLE = ['table']
  const BUSINESS = ['gtdata', 'measure', 'handler', 'dashboardConfig']
  const REPORTS = ['report', 'reportcopy']
  const SYSTEM = ['log', 'applications', 'repo']
  const NODE = ['model', 'node', 'record', 'Device', 'Development', 'driver', 'taskmanager', 'historycomputed']
  const FUNCTION = [
    'warning', 'warningarchive', 'warningclean', 'warningonce', 'archivedlog', 'cleancycle', 'cleanonce', 'archivecycle', 'archiveonce',
    'dashboard', 'Market', 'systemvariable', 'license',
    'event', 'live', 'play', 'playback', 'preview', 'ezopen', 'ptz', 'summary', 'gb28181', 'stream', 'replay', 'backup', 'flow',
    'logClean', 'job', 'jobInstance', 'flowtask', 'allflowtask', 'medialibrary', 'theme'
  ]
  const AUTH = ['user', 'department',
    'role', 'license',
    'data', 'frontSystemMenu', 'homeDashboardConfig', 'admin', 'front']
  const DATA = ['op', 'ds', 'p']
  tabs.map(item => {
    if (item.key == 'node') {
      item['child'] = tab_convert(NODE)
    } else if (item.key == 'function') {
      item['child'] = tab_convert(FUNCTION)
    } else if (item.key == 'system') {
      item['child'] = tab_convert(SYSTEM)
    } else if (item.key == 'auth') {
      item['child'] = tab_convert(AUTH)
    } else if (item.key == 'business') {
      item['child'] = tab_convert(BUSINESS)
    } else if (item.key == 'table') {
      item['child'] = tab_convert(TABLE)
    } else if (item.key == 'reports') {
      item['child'] = tab_convert(REPORTS)
    } else if (item.key == 'data') {
      item['child'] = tab_convert(DATA)
    }
    else if (item.key == 'else') {
      item['child'] = tab_convert([
        ...NODE, ...FUNCTION, ...DATA,
        ...SYSTEM, ...AUTH, ...BUSINESS, ...TABLE, ...REPORTS,
        'ext', 'measurerecord',], true)
      if (item['child']?.length) {
        item['child'] = item['child'].filter(val => !val.key.includes('dashboard_'))
      }
    }
  })
  const callback = (key) => setActiveKey(key)
  const [searchTerm, setSearchTerm] = useState('');
  const [searched, setSearched] = useState(false);
  const [searchResult, setSearchResult] = useState(permission);

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
    if (searchTerm.trim() === '') {
      setSearchResult([]);
      setSearched(false)
    } else {
      const filteredData = permission.filter((item) =>
        typeof item.title === 'string' && item.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setSearchResult(filteredData);
    }
  };
  const handleSearch = () => {
    setSearched(true)
    const filteredData = permission.filter((item) =>
      typeof item.title === 'string' && item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResult(filteredData);
  };

  return (
    <div>
      <Search
        placeholder="搜索角色权限"
        allowClear
        enterButton={<SearchOutlined />}
        value={searchTerm}
        onSearch={handleSearch}
        onChange={handleSearchChange}
      />
      {
        searched ? (
          <div>
            {searchTerm && searchResult.length > 0 ? (
              <SearchResults
                searchData={searchResult}
                checkedList={checkedList}
                setCheckedList={setCheckedList}
                searchResult={searchResult}
              />
            ) : <C is="NoData" />}
          </div>
        ) : (
          <Tabs activeKey={activeKey} onChange={callback}>
            {tabs.map(tab => (
              <TabPane tab={tab.name} key={tab.key}>
                <CheckboxRow tab={tab}
                  activeKey={activeKey}
                  checkedList={checkedList}
                  setCheckedList={setCheckedList}
                  Initdata={Initdata}
                />
              </TabPane>
            ))}
          </Tabs>
        )
      }
    </div>
  )
}
const styles = {
  width: '100%',
  height: 40,
  lineHeight: '40px',
  textAlign: 'left',
  paddingLeft: '16%',
  backgroundColor: '#F6F5FA', marginBottom: '10px'
}
const style_span = {
  textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap',
  minWidth: '120px',
}
const SearchResults = ({ searchData, checkedList, setCheckedList, searchResult }) => {
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState({});

  useEffect(() => {
    const newIndeterminate = {};
    const newCheckAll = {};

    searchData.forEach(item => {
      const checkedKeys = checkedList[item.key] || [];
      const isAllChecked = checkedKeys.length === item.children?.length;
      const isSomeChecked = checkedKeys.length > 0 && checkedKeys.length < item.children?.length;

      newIndeterminate[item.key] = isSomeChecked;
      newCheckAll[item.key] = isAllChecked;
    });
    setIndeterminate(newIndeterminate);
    setCheckAll(newCheckAll);
  }, [searchData, checkedList]);

  const handleCheckAllChange = (e) => {
    const checked = e.target.checked;
    const newCheckedList = {};

    searchData.forEach(item => {
      const checkedKeys = checked ? item.children?.map(childItem => childItem.key) : [];
      newCheckedList[item.key] = checkedKeys;
      checkAll[item.key] = true
      indeterminate[item.key] = false
    });

    setCheckedList(newCheckedList);
  };

  const toLable = (data) => {
    if (data && data.length > 0) {
      return data.map(da => ({ label: da.title, value: da.key }))
    }
    return []
  }

  const handleCheckboxChange = (e, plainOptions, parentKey) => {
    const checked = e.target.checked;
    if (checked) {
      let checked_list = {};
      checked_list[parentKey] = plainOptions.map(item => item.value);
      checkAll[parentKey] = true
      setCheckedList({ ...checkedList, ...checked_list });
      setCheckAll({ ...checkAll, [parentKey]: true });
      setIndeterminate(_.omit(indeterminate, parentKey));
    } else {
      setCheckedList(_.omit(checkedList, parentKey));
      setCheckAll(_.omit(checkAll, parentKey));
    }
  };


  const onChange = (cdAllKey, checkedkeys, parentKey) => {
    let checkKey = {};
    let checked_list = {}
    checked_list[parentKey] = checkedkeys

    Object.keys(cdAllKey).forEach((key) => {
      checkKey[key] = 0;
      for (let checkedItem of checkedkeys || []) {
        if (cdAllKey[key].indexOf(checkedItem) != -1) {
          checkKey[key]++;
          checkAll[key] = checkKey[key] === cdAllKey[key].length;
          indeterminate[key] = !!checkKey[key] && (checkKey[key] < cdAllKey[key].length);
        }
      }
      if (checkKey[key] === 0) { // 选项组下仅有一个选项时取消选中     
        checkAll[key] = false;
        indeterminate[key] = false

      }
    })

    setCheckedList({ ...checkedList, ...checked_list })
    setIndeterminate(indeterminate)
    setCheckAll(checkAll)
  }



  return (
    <div>
      <div>
        <Checkbox
          indeterminate={indeterminate}
          checked={Object.values(checkAll).every(value => value)}
          onChange={handleCheckAllChange}
          style={{ margin: '20px 0px 10px 10px' }}
        >
          全选
        </Checkbox>
      </div>
      {searchData.map(item => (
        <Row gutter={[3, 16]} >
          <Col span={6}>
            <div style={styles} className="Tabs-Col">
              <Checkbox style={style_span} key={item.key} indeterminate={indeterminate[item.key]}
                checked={checkAll[item.key]}
                onChange={(e) => handleCheckboxChange(e, toLable(item && item.children || []), item.key)}>
                <Text style={{ width: '100%' }} ellipsis={{ tooltip: item.title }} >
                  {item.title}
                </Text>
              </Checkbox>
            </div>
          </Col>
          <Col span={18} >
            <div style={styles} className="Tabs-Col">
              {item.children && item.children.length > 0 ? <CheckboxCol
                checkedList={checkedList}
                onChange={onChange}
                cd={item}
                setCheckedList={setCheckedList}
              /> : null}
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
};


const CheckboxRow = ({ tab, checkedList, setCheckedList, activeKey, Initdata }) => {
  const [indeterminate, setIndeterminate] = React.useState([])      //当前tab二级控非选中状态样式
  const [allInte, setAllInte] = React.useState({})                  //当前tab一级级非选中状态样式
  const [checkAll, setCheckAll] = React.useState({
    //   homeDashboardConfig: {
    //   title: '首页画面设置',
    //   children: [ { key: 'homeDashboardConfig.view', title: '查看' } ]
    // }  
  })                //当前tab二级选中状态
  const [activeKeyCheAll, setActiveKeyCheAll] = React.useState({})  //当前tab一级状态

  // 当前tab面板数据
  const tabpanel = tabs.filter((item) => item.key == activeKey)[0] || []
  const checks = tabpanel && tabpanel.child || []
  // 单选
  const onChange = (cdAllKey, checkedkeys, parentKey, dashboard_default) => {
    let checkKey = {};
    let checked_list = {}
    checked_list[parentKey] = checkedkeys
    Object.keys(cdAllKey).forEach((key) => {
      checkKey[key] = 0;
      for (let checkedItem of checkedkeys || []) {
        if (cdAllKey[key].indexOf(checkedItem) != -1) {
          checkKey[key]++;
          checkAll[key] = checkKey[key] === cdAllKey[key].length;
          indeterminate[key] = !!checkKey[key] && (checkKey[key] < cdAllKey[key].length);
        }
      }
      if (checkKey[key] === 0) { // 选项组下仅有一个选项时取消选中
        checkAll[key] = false;
        indeterminate[key] = false
      }
    })
    let checklist = { ...checkedList, ...checked_list }
    if (dashboard_default) {
      checklist = { ...checklist, 'dashboard_detailFilter': [] }
    }
    setCheckedList(checklist)
    setIndeterminate(indeterminate)
    setCheckAll(checkAll)
  }

  // 初始化
  React.useEffect(() => {
    if (JSON.stringify(Initdata) != '{}') {
      let Indet_erminate = {}, check_All = {}, currPanel = {}
      // 以下为初始值与当前tab页数据对比处理
      const Initdatas = Object.keys(Initdata).reduce((prev, cur) => {
        prev[cur] = Initdata[cur]
        return prev
      }, {})
      checks.forEach(item => { currPanel[item.key] = item.children.map(k => k.key) })
      // 初始值验证数组
      Object.keys(Initdatas).forEach(key => {
        const currlength = currPanel[key] && currPanel[key].length
        const Initlength = Initdatas[key] && Initdatas[key].length
        if (currlength <= Initlength) {
          check_All[key] = true
        } else if (Initlength < currlength) {
          Indet_erminate[key] = true
        }
      })
      // 当前tab页二级选项选中 vs 当前原始数据 控制一级全选
      const check_AllKeys = Object.keys(check_All)
      const currPanelKeys = Object.keys(currPanel)
      const active_KeyCheAll = {}, All_Inte = {}

      if (check_AllKeys.length == currPanelKeys.length) {
        active_KeyCheAll[activeKey] = true
      } else if (check_AllKeys.length < currPanelKeys.length) {
        All_Inte[activeKey] = true
      }
      setIndeterminate(Indet_erminate)
      setCheckAll(check_All)
      setAllInte(All_Inte)
      setActiveKeyCheAll(active_KeyCheAll)
    }
  }, [])

  // 监测当前tab数据变化改变一级 二级状态
  React.useEffect(() => {
    const All = Object.keys(checkAll).filter(key => checkAll[key]) || []
    const Checks = checks.map(item => item.key) || []
    const indeterminateaArr = Object.keys(indeterminate).filter(key => indeterminate[key] === true) || []
    let activeKey_CheAll = {}
    if (All.length === Checks.length) {
      allInte[activeKey] = false
      activeKey_CheAll[activeKey] = true
      setActiveKeyCheAll({ ...activeKeyCheAll, ...activeKey_CheAll })
      setAllInte(allInte)
    } else if (((All.length > 0) && (All.length < Checks.length)) || indeterminateaArr.length) {
      allInte[activeKey] = true
      setAllInte(allInte)
      setActiveKeyCheAll(_.omit(activeKeyCheAll, activeKey))
    }
    // 处理联动一级全选
    const selectKeys = Object.keys(checkedList).filter(key => checkedList[key].length > 0)
    if (_.intersection(selectKeys, Checks).length == 0) {
      allInte[activeKey] = false
      setAllInte(allInte)

    }

  }, [checkedList])

  //二级全选
  const onCheckAllChange = (e, plainOptions, parentKey) => {
    const checked = e.target.checked
    if (checked === true) {
      let checked_list = {}
      checked_list[parentKey] = plainOptions.map(item => item.value)
      checkAll[parentKey] = true
      setCheckedList({ ...checkedList, ...checked_list })
      setIndeterminate(_.omit(indeterminate, parentKey))
      setCheckAll(checkAll)
    } else {
      setCheckedList(_.omit(checkedList, parentKey))
      setCheckAll(_.omit(checkAll, parentKey))
    }
  }

  // 一级选项
  const onAllChange = (e) => {
    const checked = e.target.checked
    let checkData = {}
    if (checked === true) {
      checks.forEach(item => {
        checkData[item.key] = item && item.children && item.children.map(check => check.key)
        checkAll[item.key] = true
        indeterminate[item.key] = false
      })
      activeKeyCheAll[activeKey] = true
      // console.log({ ...checkedList, ...checkData }, indeterminate, checkAll, 8989)
      setCheckedList({ ...checkedList, ...checkData })
      setIndeterminate(indeterminate)
      setCheckAll(checkAll)
      setActiveKeyCheAll(activeKeyCheAll)

    } else {
      checks.forEach(item => {
        checkedList = _.omit(checkedList, item.key)
        checkAll[item.key] = false
        indeterminate[item.key] = false
      })
      activeKeyCheAll[activeKey] = false
      setCheckedList({ ...checkedList })
      setIndeterminate(indeterminate)
      setCheckAll(checkAll)
      setActiveKeyCheAll(activeKeyCheAll)
    }
  }

  const styles = {
    whiteSpace: 'nowrap',
    width: '100%',
    height: 40,
    lineHeight: '40px',
    textAlign: 'left',
    paddingLeft: '16%',
    backgroundColor: 'rgb(246 245 250 / 40%)', marginBottom: '10px'
  }
  const style_span = {
    textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap',
    minWidth: '120px',
  }

  let tabChild = tab.child
  if (activeKey == 'else') {
    tabChild = tab?.child?.length ? tabChild.filter(item => (item.key.indexOf('dashboard_') < 0)) : []
  }
  return tabChild.length > 0 ?
    <div><Checkbox style={{ margin: '0px 0px 10px 10px' }} indeterminate={allInte[activeKey]}
      checked={activeKeyCheAll[activeKey]} onChange={onAllChange}>全选</Checkbox> {
        tabChild.map(cd => (
          <Row gutter={[3, 16]} >
            <Col span={6}>
              <div style={styles} className="Tabs-Col">
                <Checkbox style={style_span} key={cd.key} indeterminate={indeterminate[cd.key]} checked={checkAll[cd.key]}
                  onChange={(e) => onCheckAllChange(e, toLable(cd && cd.children || []), cd.key)}>
                  <Text style={{ width: '100%' }} ellipsis={{ tooltip: cd.title }} >
                    {cd.title}
                  </Text>
                </Checkbox>
              </div>
            </Col>
            <Col span={18} >
              <div style={styles} className="Tabs-Col">
                {cd && cd.children && cd.children.length > 0 ? <CheckboxCol cd={cd} checkedList={checkedList} onChange={onChange} setCheckedList={setCheckedList} /> : null}
              </div>
            </Col>
          </Row>
        ))}</div> : <NoData /> //<Empty image={require('./../../../icon/homeIcon/noData.png')} imageStyle={{ height: 100 }} description="暂无数据"></Empty>
}

const toLable = (data) => {
  if (data && data.length > 0) {
    return data.map(da => ({ label: da.title, value: da.key }))
  }
  return []
}

const CheckboxCol = (props) => {
  const [visible, setVisible] = React.useState({ show: false, type: null })
  const { checkedList, onChange, cd: { key, children }, setCheckedList } = props
  const options = toLable(children) // 转换数据格式 { label:'',value:'' }
  const cdAllKey = { [key]: options.map(item => item.value) } //点击行数据 key:[...]

  const handleChange = (e, type) => {
    const value = e.target.value
    const checked = e.target.checked
    let dashboardList = checkedList?.[type]?.length ? checkedList[type] : []
    if (checked) {
      let newChecked = []
      newChecked = [...dashboardList, value]
      onChange({ [type]: newChecked }, newChecked, type)
    } else {
      if (dashboardList?.length > 0) {
        let newCheckedList = dashboardList.filter(val => val != value)
        let list = newCheckedList?.length ? newCheckedList : ''
        onChange({ [type]: list }, list, type)
      } else {
        onChange({ [type]: '' }, '', type)
      }
    }
  }

  if (key == 'dashboard') {
    return <div>
      {
        options.map(item => {
          if (item?.value == 'dashboard.add') {
            return <Checkbox checked={checkedList?.[key] && checkedList[key].indexOf(item?.value) > -1 ? true : false} value={item?.value} onChange={(e) => handleChange(e, key)}>{item?.label}</Checkbox>
          } else {
            return <>
              <Checkbox checked={checkedList?.[key] && checkedList[key].indexOf(item?.value) > -1 ? true : false}
                value={item?.value} onChange={(e) => handleChange(e, key)}>{item?.label}</Checkbox>
              <Button disabled={checkedList?.[key] && checkedList[key].indexOf(item?.value) > -1 ? false : true} size="small" onClick={() => { setVisible({ show: true, type: item?.value }) }} style={{ marginRight: '.4rem' }}>选择画面</Button>
            </>
          }
        })
      }
      <SelectDashboard {...props} cdAllKey={cdAllKey} visible={visible} setVisible={setVisible} setCheckedList={setCheckedList}></SelectDashboard>
    </div>
  } else {
    return <CheckboxGroup options={options} value={checkedList[key]} onChange={(checkedValue) => onChange(cdAllKey, checkedValue, key)} />
  }
}

const SelectDashboard = props => {
  const { visible, setVisible, cdAllKey, cd, key, checkedList, onChange, setCheckedList } = props
  const [dashboard, setDashboard] = React.useState({ loading: false, data: [], currentData: [] })
  const [currentPage, setCurrentPage] = React.useState(1)
  const [searchTotal, setSearchTotal] = React.useState([])
  const [checkAll, setCheckAll] = React.useState(false)
  const [checkAdd, setCheckAdd] = React.useState(false)
  const [indeterminate, setIndeterminate] = React.useState(true)
  const [a, setA] = React.useState([])

  let dashboardObj = {
    'dashboard.view': '画面查看',
    'dashboard.view': '画面修改',
    'dashboard.view': '画面删除'
  }

  React.useEffect(() => {
    let fields = ["name", "type", "cover", "focus", "isDelete"]
    let wheres = { isDelete: { "$ne": true } }

    let str = {
      sort: { createTime: -1 },
      project: { name: 1, type: 1, cover: 1, focus: 1, isDelete: 1, catalog: 1, createTime: 1 },
      filter: { isDelete: { "$ne": true } }, withCount: true
    }
    let queryStr = encodeURIComponent(JSON.stringify(str))

    setDashboard({ loading: true })
    api({ name: 'core/dashboard' }).fetch(`?query=${queryStr}`, {}).then(({ json }) => {
      setDashboard({ loading: false, data: json, currentData: json.slice(0, 15) })
    })
  }, [])

  const deafult_permission = (checkListKeys, dashboard_type, dashboard_default_type) => {
    const defaultArr = ['view', 'edit', 'delete']
    const obj = {}
    checkListKeys.forEach(val => {
      defaultArr.forEach(v => {
        if (val[0].indexOf(dashboard_default_type) > -1 && v == dashboard_type) {
          setCheckAdd(true)
          obj[dashboard_type] = true
        } 
      })
    })

    return obj
  }

  React.useEffect(() => {
    if (dashboard?.data?.length && visible?.type && checkedList) {
      let newCheckList = _.cloneDeep(checkedList) || {}
      const type = visible?.type && visible?.type.substr(visible?.type.lastIndexOf('.') + 1)
      let arr = []
      const defaultArr = ['view', 'edit', 'delete']
      const checkListKeys = Object.entries(checkedList)
      checkListKeys.forEach(val => {
        dashboard.data.forEach(item => {
          if (val[0] == `dashboard_${item?.id}`) {
            if (val[1].indexOf(visible.type.replace('dashboard', `dashboard_${item?.id}`)) > -1) {
              arr = [...arr, visible.type.replace('dashboard', `dashboard_${item?.id}`)]
            }
          }
        })
      })
      const default_all = deafult_permission(checkListKeys, type, `dashboard_deafult${type}`)
      if(default_all?.[type]) {
        setCheckAll(true)
        setCheckAdd(true)
        const keys = Object.keys(newCheckList)
        const findKeys = dashboard?.data.filter(v => {
          let index = arr.findIndex(i => i == `dashboard_${v.id}.${type}`)
          if(index == -1) return v 
        })
        if(findKeys.length > 0) {
          findKeys.forEach(i => {
            onChange({ [`dashboard_${i.id}`]: [`dashboard_${i.id}.${type}`] }, [`dashboard_${i.id}.${type}`], `dashboard_${i.id}`)
          })
        }
      } else {
        if (dashboard?.data?.length == arr?.length) {
          setCheckAll(true)
          deafult_permission(checkListKeys, type, `dashboard_deafult${type}`)
        } else if (arr?.length == 0 || dashboard?.data?.length == 0 || dashboard?.data?.length != arr?.length) {
          setCheckAll(false)
          setCheckAdd(false)
        }
      }
    }
  }, [JSON.stringify(dashboard.data), JSON.stringify(checkedList), visible?.type])

  const handleOk = () => {
    setVisible({ show: false, type: null })
    setCheckAll(false); setCheckAdd(false)
  }

  const handleChange = (e, type) => {
    const value = e.target.value
    const checked = e.target.checked
    let dashboardList = checkedList?.[type]?.length ? checkedList[type] : []
    if (checked) {
      let newChecked = []
      if (value.indexOf('.edit') > -1 || value.indexOf('.delete') > -1) {
        newChecked = dashboardList?.length && dashboardList.indexOf(`${type}.view`) > -1 ? [...dashboardList, value] : [...dashboardList, `${type}.view`, value]
      } else {
        newChecked = [...dashboardList, value]
      }
      onChange({ [type]: newChecked }, newChecked, type, 'dashboard_default')
    } else {
      if (dashboardList?.length > 0) {
        let newCheckedList = dashboardList.filter(val => val != value)
        let list = newCheckedList?.length ? newCheckedList : ''
        onChange({ [type]: list }, list, type)
      } else {
        onChange({ [type]: '' }, '', type)
      }
    }
  }

  const PaginationChange = (page, pageSize) => {
    setCurrentPage(page)
    let start = (page - 1) * pageSize
    let end = page * pageSize
    setDashboard(state => ({ ...state, currentData: dashboard.data.slice(start, end) }))
  }

  const handleSearch = (e) => {
    const value = e.target.value
    let filterData = dashboard.data?.length ? dashboard.data.filter(item => item?.name.includes(value)).slice(0, 15) : []
    setDashboard(state => ({ ...state, currentData: filterData }))
    if (value) {
      setSearchTotal(filterData)
    } else {
      setSearchTotal([])
    }
  }

  const onCheckAllChange = (e) => {
    const checked = e.target.checked
    let newCheckList = _.cloneDeep(checkedList) || {}
    const type = visible?.type && visible?.type.substr(visible?.type.lastIndexOf('.') + 1)
    if (dashboard?.data?.length && visible?.type) {
      if (checked) {
        dashboard.data.forEach(item => {
          if (newCheckList[`dashboard_${item.id}`]) {
            newCheckList[`dashboard_${item.id}`] = Array.from(new Set([...newCheckList[`dashboard_${item.id}`], visible.type.replace('dashboard', `dashboard_${item?.id}`)]))
          } else {
            newCheckList[`dashboard_${item.id}`] = [visible.type.replace('dashboard', `dashboard_${item?.id}`)]
          }
        })
      } else {
        dashboard.data.forEach(item => {
          if (newCheckList[`dashboard_${item.id}`]) {
            if (newCheckList[`dashboard_${item.id}`].indexOf(visible.type.replace('dashboard', `dashboard_${item?.id}`)) > -1) {
              newCheckList[`dashboard_${item.id}`].splice(newCheckList[`dashboard_${item.id}`].indexOf(`dashboard_${item.id}.${type}`), 1)
            }
          }
        })

        if (Object.keys(newCheckList).indexOf(`dashboard_deafult${type}`) > -1) {
          delete newCheckList[`dashboard_deafult${type}`]
        }
      }
    }
    setCheckedList(newCheckList)
    setIndeterminate(false)
    setCheckAll(checked)
  }

  const getNewCheckList = (newCheckList, type, check) => {
    if (check) {
      newCheckList = { ...newCheckList, [`dashboard_deafult${type}`]: [] }
    } else {
      if (Object.keys(newCheckList).indexOf(`dashboard_deafult${type}`) > -1) {
        delete newCheckList[`dashboard_deafult${type}`]
      }
    }
    return newCheckList
  }

  const onCheckAddChange = e => {
    const checked = e.target.checked
    let newCheckList = _.cloneDeep(checkedList) || {}
    const arr = ['view', 'eidt', 'delete']
    const type = visible?.type && visible?.type.substr(visible?.type.lastIndexOf('.') + 1)
    if (type) {
      if (checked) {
        arr.forEach(val => {
          if (type == val) newCheckList = getNewCheckList(newCheckList, type, checked)
        })
      } else {
        arr.forEach(val => {
          if (type == val) newCheckList = getNewCheckList(newCheckList, type, checked)
        })
      }
    }
    setCheckedList(newCheckList)
    setCheckAdd(checked)
  }

  const type = visible?.type && visible?.type.substr(visible?.type.lastIndexOf('.') + 1)
  const showCheckAll = Object.keys(checkedList).indexOf(`dashboard_deafult${type}`)

  return <Modal width="80%" visible={visible.show} title={
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span>{'画面管理'}</span>
      <Input placeholder='搜索画面名称' style={{ marginLeft: '20px', width: '200px' }} onChange={handleSearch} />
    </div>
  }
    onOk={handleOk} onCancel={() => { setVisible({ ...visible, show: false, type: null }); setCheckAll(false); setCheckAdd(false) }}>
    <span style={{ textAlign: 'right' }}>
      <Checkbox onChange={onCheckAllChange} checked={checkAll}>全选</Checkbox>
      {checkAll || showCheckAll ? <Checkbox onChange={onCheckAddChange} checked={checkAdd}>新增画面默认选中</Checkbox> : null}
      <Pagination current={currentPage} showSizeChanger={false} pageSize={15} total={searchTotal?.length || dashboard?.data?.length} onChange={PaginationChange} />
    </span>
    <Row gutter={16}>
      {
        dashboard?.currentData?.length ? dashboard.currentData.map(item => {
          return <Col span={8} xs={24} sm={12} md={12} lg={8} xl={6} xxl={4} style={{ margin: '.5rem 0' }}>
            <Card>
              <div className="cover-div">
                <span className="cover-focus-span">
                  {
                    visible?.type ? <Checkbox
                      checked={checkedList[`dashboard_${item?.id}`] && checkedList[`dashboard_${item?.id}`].indexOf(visible.type.replace('dashboard', `dashboard_${item?.id}`)) > -1 ? true : false}
                      value={`${visible.type.replace('dashboard', `dashboard_${item?.id}`)}`}
                      onChange={(e) => handleChange(e, `dashboard_${item?.id}`)}></Checkbox> : null
                  }
                </span>
                {
                  item?.cover ? <div style={{ height: 120, overflow: 'hidden' }} ><img src={item.cover} width="100%" /></div> :
                    <div className="cover-div-picture" style={{ height: 120, textAlign: 'center', lineHeight: '142px' }} ><Icon type="picture" style={{ fontSize: 50, color: '#ffffff' }} /></div>
                }
                <div style={{ overflow: 'hidden', wordBreak: 'keep-all', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginTop: '.5rem' }} >
                  <Tag color={{ 'normal': 'blue', 'model': 'green', 'node': 'red', 'table': 'pink', 'slideMaster': 'orange' }[item.type]}>
                    {{ 'normal': '普通', 'model': '模型', 'node': '资产', 'table': '工作表', 'slideMaster': '母版' }[item.type]}
                  </Tag>
                  <span>{item?.name}</span>
                </div>
              </div>
            </Card>
          </Col>
        }) : <div style={{ margin: '0 auto' }}><C is="NoData" /></div>
      }
    </Row>
  </Modal>
}
